import React from 'react';

const Vue_Component_Instance = () => {
  return (
    <div>
      <h1>Vue_Component_Instance Component</h1>
      <p>This is the Vue_Component_Instance tutorial page.</p>
    </div>
  );
}

export default Vue_Component_Instance;
